import React from "react";
import { Card, Button, Breadcrumb } from "antd";
import { Link } from "react-router-dom";

const gridStyle = {
  width: "25%",
  textAlign: "center",
};
const App = () => (
  <Card
    title={
      <Breadcrumb
        items={[
          {
            title: "Beranda",
          },

          {
            title: "Webmap",
          },
        ]}
      />
    }
  >
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="example"
            src={
              process.env.PUBLIC_URL + "/static/images/peta_garis_pantai.png"
            }
          />
        }
        actions={[
          <Link
            target="_blank"
            to="https://geoservices.big.go.id/portal/apps/webappviewer/index.html?id=114dc269c07446ebaa95307bf423fcf6"
          >
            <Button type="primary">Lihat Peta</Button>
          </Link>,
        ]}
        title="Peta Garis Pantai"
      ></Card>
    </Card.Grid>
    <Card.Grid hoverable style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="example"
            src={
              process.env.PUBLIC_URL + "/static/images/peta_batas_wilayah.png"
            }
          />
        }
        actions={[
          <Link
            target="_blank"
            to="https://geoservices.big.go.id/portal/apps/webappviewer/index.html?id=49bda2cefd3f4b92aa726300bcdb40f7
"
          >
            <Button type="primary">Lihat Peta</Button>
          </Link>,
        ]}
        title="Peta Batas Wilayah"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="example"
            src={
              process.env.PUBLIC_URL +
              "/static/images/peta_index_ketersediaan.png"
            }
          />
        }
        actions={[
          <Link
            target="_blank"
            to="https://geoservices.big.go.id/portal/apps/webappviewer/index.html?id=4293dfc9104a4809a6cf2d396ced4e6b"
          >
            <Button type="primary">Lihat Peta</Button>
          </Link>,
        ]}
        title="Peta Indeks Ketersediaan DG/IG Dasar"
      ></Card>
    </Card.Grid>
    <Card.Grid style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="example"
            src={process.env.PUBLIC_URL + "/static/images/peta_index_unduh.png"}
          />
        }
        actions={[
          <Link
            target="_blank"
            to="https://geoservices.big.go.id/portal/apps/webappviewer/index.html?id=cf20eb402f114671a7e1194e22e527e8"
          >
            <Button type="primary">Lihat Peta</Button>
          </Link>,
        ]}
        title="Peta Indeks Unduh dan Basemap"
      ></Card>
    </Card.Grid>
    <Card.Grid hoverable style={gridStyle}>
      <Card
        hoverable
        cover={
          <img
            alt="Peta Data Stunting"
            src={process.env.PUBLIC_URL + "/static/images/Stunting.jpg"}
          />
        }
        actions={[
          <Link to="/stunting">
            <Button type="primary">Lihat Peta</Button>
          </Link>,
        ]}
        title="Peta Data Stunting"
      />
    </Card.Grid>
  </Card>
);
export default App;
